module.exports = __webpack_public_path__ + "img/V8SUPERCARS.0b5788c.jpg";